import aboutRaw from "./about.md?raw";
import connectingRaw from "./connecting.md?raw";
import corsRaw from "./cors.md?raw";
import proxyModeRaw from "./proxy-mode.md?raw";
import dashboardWorkflowRaw from "./dashboard-workflow.md?raw";
import discoverWorkflowRaw from "./discover-workflow.md?raw";
import metricsWorkflowRaw from "./metrics-workflow.md?raw";
import logsWorkflowRaw from "./logs-workflow.md?raw";
import tracesWorkflowRaw from "./traces-workflow.md?raw";
import servicePerformanceRaw from "./service-performance.md?raw";
import profilingWorkflowRaw from "./profiling-workflow.md?raw";
import visualizationsRaw from "./visualizations.md?raw";
import keyboardShortcutsRaw from "./keyboard-shortcuts.md?raw";
import consoleRaw from "./console.md?raw";
import dataStreamsRaw from "./data-streams.md?raw";
import chatRaw from "./chat.md?raw";
import llmSettingsRaw from "./llm-settings.md?raw";
import clusterOverviewRaw from "./cluster-overview.md?raw";
import clusterHealthRaw from "./cluster-health.md?raw";
import dashboardManagementRaw from "./dashboard-management.md?raw";
import usersRolesRaw from "./users-roles.md?raw";
import indicesRaw from "./indices.md?raw";
import ingestPipelinesRaw from "./ingest-pipelines.md?raw";
import addDataRaw from "./add-data.md?raw";
import apiKeysRaw from "./api-keys.md?raw";
import fleetRaw from "./fleet.md?raw";
import kubernetesRaw from "./kubernetes.md?raw";
import ilmRaw from "./ilm.md?raw";
import templatesRaw from "./templates.md?raw";
import nodesRaw from "./nodes.md?raw";
import investigateRaw from "./investigate.md?raw";
import tasksRaw from "./tasks.md?raw";
import watcherRaw from "./watcher.md?raw";
import hostsRaw from "./hosts.md?raw";
import storageExplorerRaw from "./storage-explorer.md?raw";
import transformsRaw from "./transforms.md?raw";
import snapshotsRaw from "./snapshots.md?raw";
import easterEggModeRaw from "./easter-egg-mode.md?raw";

export interface DocSection {
  id: string;
  title: string;
  image?: string;
  body: string[];
}

/**
 * Parse a simple Markdown string into a DocSection.
 * The first `# Heading` line becomes the title; the remaining
 * blank-line-separated blocks become the body paragraphs.
 * Markdown punctuation escape sequences (e.g. `\_`) are unescaped in the output.
 */
export function parseDocSection(id: string, raw: string): DocSection {
  const lines = raw.trim().split("\n");
  const titleLine = lines.find((l) => l.startsWith("# "));
  const title = titleLine?.slice(2).trim() ?? id;
  const bodyText = lines
    .filter((l) => !l.startsWith("# "))
    .join("\n")
    .trim();
  const body = bodyText
    .split(/\n\n+/)
    .map((p) => p.trim().replace(/\\([\\`*_{}[\]()#+\-.!|>~])/g, "$1"))
    .filter(Boolean);
  return { id, title, body };
}

const logoUrl = `${import.meta.env.BASE_URL}logo.png`;

const sections: DocSection[] = [
  { ...parseDocSection("about", aboutRaw), image: logoUrl },
  parseDocSection("connecting", connectingRaw),
  parseDocSection("cors", corsRaw),
  parseDocSection("proxy-mode", proxyModeRaw),
  parseDocSection("dashboard-workflow", dashboardWorkflowRaw),
  parseDocSection("discover-workflow", discoverWorkflowRaw),
  parseDocSection("metrics-workflow", metricsWorkflowRaw),
  parseDocSection("logs-workflow", logsWorkflowRaw),
  parseDocSection("traces-workflow", tracesWorkflowRaw),
  parseDocSection("service-performance", servicePerformanceRaw),
  parseDocSection("profiling-workflow", profilingWorkflowRaw),
  parseDocSection("visualizations", visualizationsRaw),
  parseDocSection("keyboard-shortcuts", keyboardShortcutsRaw),
  parseDocSection("console", consoleRaw),
  parseDocSection("data-streams", dataStreamsRaw),
  parseDocSection("chat", chatRaw),
  parseDocSection("llm-settings", llmSettingsRaw),
  parseDocSection("cluster-overview", clusterOverviewRaw),
  parseDocSection("cluster-health", clusterHealthRaw),
  parseDocSection("dashboard-management", dashboardManagementRaw),
  parseDocSection("easter-egg-mode", easterEggModeRaw),
  parseDocSection("users-roles", usersRolesRaw),
  parseDocSection("indices", indicesRaw),
  parseDocSection("ingest-pipelines", ingestPipelinesRaw),
  parseDocSection("add-data", addDataRaw),
  parseDocSection("api-keys", apiKeysRaw),
  parseDocSection("fleet", fleetRaw),
  parseDocSection("kubernetes", kubernetesRaw),
  parseDocSection("hosts", hostsRaw),
  parseDocSection("nodes", nodesRaw),
  parseDocSection("ilm", ilmRaw),
  parseDocSection("templates", templatesRaw),
  parseDocSection("storage-explorer", storageExplorerRaw),
  parseDocSection("watcher", watcherRaw),
  parseDocSection("tasks", tasksRaw),
  parseDocSection("investigate", investigateRaw),
  parseDocSection("transforms", transformsRaw),
  parseDocSection("snapshots", snapshotsRaw),
];

export default sections;
